import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePrefersReducedMotion } from "@/hooks/usePrefersReducedMotion";
import { useLenis } from "@/providers/LenisProvider";
import { scrollToElement, scrollToTop } from "@/lib/smooth-scroll";

/**
 * Po każdej zmianie trasy ustawia widok na początek podstrony (tytuł),
 * a gdy adres zawiera hash (#sprint, #contact) — płynnie przewija
 * do wskazanej sekcji, także przy wejściu z innej podstrony.
 *
 * Preferencja "ogranicz ruch" jest respektowana: wtedy przewijanie
 * jest natychmiastowe, bez animacji.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const reducedMotion = usePrefersReducedMotion();
  const lenis = useLenis();

  // Wejście / odświeżenie strony: zawsze zaczynamy od góry (bez przywracania pozycji).
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    if (!window.location.hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }, []);

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      // Sekcja może pochodzić z leniwie ładowanej trasy — dajemy jej klatkę na montowanie.
      const raf = requestAnimationFrame(() => {
        const target = document.getElementById(id);
        if (target) {
          scrollToElement(target, { lenis, reducedMotion });
        } else {
          scrollToTop({ lenis, reducedMotion: true });
        }
      });
      return () => cancelAnimationFrame(raf);
    }

    // Zmiana podstrony: bez animacji, żeby nie "przelatywać" przez całą poprzednią stronę.
    scrollToTop({ lenis, reducedMotion: true });
  }, [pathname, hash, lenis, reducedMotion]);

  return null;
}

export default ScrollToTop;
